/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
define(["require", "exports", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Link", "react", "../Resources", "./Utils", "./RunDetails.scss"], function (require, exports, String_1, Link_1, React, Resources, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function getRunDetailsText(annotations, jobAndPipelineDetails, createdAgo) {
        var pipelineDetails = {};
        if (jobAndPipelineDetails) {
            pipelineDetails = jobAndPipelineDetails;
        }
        else if (annotations) {
            pipelineDetails = Utils_1.Utils.getPipelineDetails(annotations);
        }
        else {
            return "";
        }
        if (!createdAgo && !pipelineDetails.jobName) {
            return null;
        }
        var trimmedJobName = pipelineDetails.jobName && pipelineDetails.jobName.replace(/^"|"$/g, "");
        var first = createdAgo
            ? (trimmedJobName
                ? String_1.localeFormat(Resources.ServiceCreatedWithPipelineText, createdAgo, trimmedJobName)
                : String_1.localeFormat(Resources.CreatedAgo, createdAgo))
            : trimmedJobName;
        var runElement = pipelineDetails.runName
            ? (pipelineDetails.runUrl
                ? (React.createElement(Link_1.Link, { className: "run-name-link bolt-table-link", rel: "noopener noreferrer", href: pipelineDetails.runUrl },
                    " ",
                    "#" + pipelineDetails.runName,
                    " "))
                : "#" + pipelineDetails.runName)
            : undefined;
        var second = runElement;
        if (pipelineDetails.pipelineName) {
            // Trying to format the resource string with {0} possibly being a link.
            // First put the pipeline name, and in the place on run, put {0}
            // Pipeline name might have surrounding quotes
            var runText = String_1.localeFormat(Resources.RunInformationForWorkload, "{0}", pipelineDetails.pipelineName.replace(/^"|"$/g, ""));
            // Find index of the run placeholder
            var indexOfRun = runText.indexOf("{0}");
            second = (React.createElement(React.Fragment, null,
                runText.substring(0, indexOfRun - 1),
                runElement,
                runText.substring(indexOfRun + 3)));
        }
        return (React.createElement(React.Fragment, null,
            first,
            second
                ? React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "runs-bullet" }, "\u2022"),
                    second)
                : undefined));
    }
    exports.getRunDetailsText = getRunDetailsText;
});
